import { User, UserRole } from 'src/backoffice-app-code/features/Auth/models/User';
import { contentEditorNavConfig } from './contentEditorNavConfig';
import { getDistributorPartnerAdminNavConfig } from './distributorPartnerAdminNavConfig';
import { endUserNavConfig } from './endUserNavConfig';
import { insuranceAgentNavConfig } from './insuranceAgentNavConfig';
import { adminNavConfig } from './adminNavConfig';
import { productApprovalOperatorNavConfig } from './productApprovalOperatorNavConfig';
import { getRetailerPartnerAdminNavConfig } from './retailerPartnerAdminNavConfig';
import { insuranceAdminNavConfig } from './insuranceAdminNavConfig';
import { underwriterNavConfig } from './underwriterNavConfig';

export const getNavConfigForUser = (user: User | undefined) => {
  if (user?.userRole === UserRole.PlatformAdmin) {
    return adminNavConfig;
  } else if (user?.userRole === UserRole.ContentEditor) {
    return contentEditorNavConfig;
  } else if (user?.userRole === UserRole.EndUser) {
    return endUserNavConfig;
  } else if (user?.userRole === UserRole.InsuranceAgent) {
    return insuranceAgentNavConfig;
  } else if (user?.userRole === UserRole.InsuranceAdmin) {
    console.log('nista?');
    return insuranceAdminNavConfig;
  } else if (user?.userRole === UserRole.InsuranceUnderwriter) {
    return underwriterNavConfig;
  } else if (user?.userRole === UserRole.ProductApprovalOperator) {
    return productApprovalOperatorNavConfig;
  } else if (user?.userRole === UserRole.DistributorPartnerAdmin) {
    return getDistributorPartnerAdminNavConfig(user);
  } else if (user?.userRole === UserRole.RetailerPartnerAdmin) {
    return getRetailerPartnerAdminNavConfig(user);
  }

  return [];
};
